
export enum WorkRegionState {
    UNREFERENCED = "UNREFERENCED",
    REFERENCED = "REFERENCED"
}

export interface WorkRegion {
    id: number;
    name: string;
    state: WorkRegionState;
}
